module.exports = __webpack_public_path__ + "img/config_emt.846a724a.png";